'use client';
var classes = {"root":"m_e2f5cd4e","controls":"m_95e17d22","control":"m_80b4b171"};

export { classes as default };
//# sourceMappingURL=NumberInput.module.css.mjs.map
